import { Component } from '@angular/core';
import { ClientService } from '@shared/services/client/client.service';
import { environment } from '@environments/environment';
import { ActiveAccountingPeriodDetails } from '@shared/models/client/client.model';
import { CommonModule, DatePipe } from '@angular/common';


@Component({
  selector: 'avenir-header-accounting-period',
  standalone: true,
  imports: [
    CommonModule
  ],
  providers: [
    DatePipe
  ],
  templateUrl: './header-accounting-period.component.html',
  styleUrl: './header-accounting-period.component.scss'
})
export class HeaderAccountingPeriodComponent {
  activePeriod: ActiveAccountingPeriodDetails = {} as ActiveAccountingPeriodDetails;
  openPeriod: {
    startDate: string;
    endDate: string;
    gracePeriodDate: string;
  } = {} as {
    startDate: string;
    endDate: string;
    gracePeriodDate: string;
  }

  constructor (
    private clientService: ClientService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.clientService.getActiveAccountingPeriod(environment.CLIENT_ID).subscribe({
      next: (response) => {
        this.activePeriod = response;
        if (this.activePeriod?.openAccountingPeriods.length > 0) {
          if (this.activePeriod?.openAccountingPeriods[0]) {
            this.openPeriod.startDate = this.datePipe.transform(this.activePeriod.openAccountingPeriods[0].dateStart, 'MMM y')!;
          }

          if (this.activePeriod?.openAccountingPeriods[1]) {
            this.openPeriod.endDate = this.datePipe.transform(this.activePeriod.openAccountingPeriods[1].dateStart, 'MMM y')!;
            this.openPeriod.gracePeriodDate = this.activePeriod.openAccountingPeriods[1].graceEndDate
          }
        }
      }
    })
  }

}
